const Toggle = ({
  onClick,
  checked,
  isDisabled = false,
}: {
  onClick?: () => void;
  checked: boolean;
  isDisabled?: boolean;
}) => {
  const bgStyle = () => {
    if (isDisabled) {
      return "bg-gray-light";
    } else {
      return checked ? "bg-primary" : "bg-gray";
    }
  };

  return (
    <div
      className={`relative inline-block h-[20px] w-[38px] rounded-full transition-colors duration-300 ${bgStyle()} cursor-pointer`}
      onClick={onClick}
    >
      <div
        className={`absolute left-[1px] top-[1px] h-[18px] w-[18px] transform rounded-full bg-white shadow-md transition-transform duration-300 ${
          checked ? "translate-x-[17px]" : ""
        }`}
      />
    </div>
  );
};

export default Toggle;
